<template>
    <div :style="messageColors" class="sc-message--file">
        <span v-if="isGroupMessage" class="whatsapp-number-first" @click.stop="showWhatsappChatStarterModal = true">
            <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }"
            >{{ whatsappAuthorName }} - {{ whatsappAuthorNumber }}</a
            >
        </span>
        <div class="sc-message--file-icon">
            <img :src="data.file.url" class="sc-image" />
        </div>
        <div :style="messageColors" class="sc-message--file-name">
            <a :href="data.file.url ? data.file.url : '#'" target="_blank">{{ data.file.name || "" }}</a>
        </div>
        <div :style="messageColors" class="sc-message--file-text">
            {{ data.text }}
            <p v-if="data.meta" :style="messageColors" class="sc-message--meta">
                {{ data.meta }}
            </p>
        </div>

        <div
            v-if="isGroupMessage"
            style="
                display: flex;
                flex-direction: row;
                justify-content: end;
                align-items: center;
                padding: 0 0.3rem;
            "
        >
            <span
                class="sc-message-meta-new whatsapp-number"
                @click.stop="showWhatsappChatStarterModal = true"
            >
                <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }"
                >{{ whatsappAuthorName }} - {{ whatsappAuthorNumber }}</a
                >
            </span>
        </div>

        <Modal2
            v-if="showWhatsappChatStarterModal"
            @cancel="showWhatsappChatStarterModal = false"
            :title="$t('message.whatsappChatStart')"
            :showFooter="false"
        >
            <WhatsappChatStarter
                :default-phone-number="whatsappAuthorNumber"
                channel-override
                phone-number-override
                @close="showWhatsappChatStarterModal = false"
                :default-name="whatsappAuthorName"
            />
        </Modal2>
    </div>
</template>

<script>
import _ from "lodash";
import Modal2 from "../../common/Modal2.vue";
import WhatsappChatStarter from "../../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import StringUtils from "../../../utils/StringUtils";

export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        messageColors: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showWhatsappChatStarterModal: false,
        };
    },
    computed: {
        isGroupMessage() {
            return !!_.get(this.data, "whatsappAuthor.author");
        },
        whatsappAuthorNumber() {
            return _.get(this.data, "whatsappAuthor.author", "").replace(/[^0-9]/g, "");
        },
        whatsappAuthorName() {
            return _.get(this.data, "whatsappAuthor.authorName", "");
        },
    },
    methods: {
        getWhatsappNumberColor() {
            if (this.isGroupMessage) {
                const colors = ["#1a5fb4", "#813d9c", "#c64600", "#2ec27e", "#e01b24", "#3584e4", "#9141ac", "#f5c211"];
                const index = Math.abs(this.hashCode(this.whatsappAuthorNumber)) % colors.length;
                return colors[index];
            }
            return this.messageColors.color;
        },
        hashCode(str) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                const char = str.charCodeAt(i);
                hash = (hash << 5) - hash + char;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        },
    },
    components: {
        Modal2,
        WhatsappChatStarter,
    },
};
</script>

<style scoped>
.sc-message--file {
    border-radius: 6px;
    font-weight: 300;
    font-size: 14px;
    line-height: 1.4;
    /* white-space: pre-wrap; */
    -webkit-font-smoothing: subpixel-antialiased;
}

.sc-message--content.sent .sc-message--file {
    word-wrap: break-word;
}

.sc-message--file-icon {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    margin-top: 15px;
    margin-bottom: 0px;
}

.sc-image {
    max-width: 100%;
    min-width: 100%;
}

.sc-message--file-text {
    padding: 17px 20px;
    border-radius: 6px;
    font-weight: 300;
    font-size: 14px;
    line-height: 1.4;
    white-space: pre-wrap;
    -webkit-font-smoothing: subpixel-antialiased;
}

.sc-message--file-name {
    color: white;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 0;
    font-size: x-small;
    text-align: center;
}

.sc-message--file-name a {
    text-decoration: none;
    color: #ece7e7;
}

.sc-message--file-name a:hover {
    color: white;
}

.sc-message--content.sent .sc-message--file-text {
    color: white;
    background-color: #4e8cff;
    word-wrap: break-word;
}

.sc-message--content.received .sc-message--file {
    color: #263238;
    background-color: #f4f7f9;
    margin-right: 40px;
}

.sc-message--content.received .sc-message--file-name {
    color: #000;
}

.sc-message--content.received .sc-message--file a {
    color: rgba(43, 40, 40, 0.7);
}

.sc-message--content.received .sc-message--file a:hover {
    color: #0c0c0c;
}

.whatsapp-number {
    cursor: pointer;

    a {
        text-decoration: underline;
    }
}

.whatsapp-number-first {
    cursor: pointer;
    font-size: smaller;
    font-weight: 200;
    letter-spacing: 2px;

    a {
        &:hover {
            text-decoration: underline;
        }
    }

    padding: 5px;
}

.sc-message-meta-new {
    font-size: 8px;
    font-weight: 300;
    color: white;
    text-align: right;
    border-radius: 6px;
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 0px !important;
    margin: 5px !important;
    margin-right: 14px !important;
    margin-bottom: 14px !important;
}
</style>
